export default __webpack_public_path__ + "static/media/clock_blue.e0ca407d.svg";